import { useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { Loader2, LockKeyhole } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { formatApiError } from "@/lib/api";

export default function StaffLogin() {
  const { user, login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);
  if (user) return <Navigate to="/staff" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setErr("");
    try {
      await login(email, password);
      nav("/staff");
    } catch (ex) {
      setErr(formatApiError(ex));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="rrb-staff grid min-h-screen place-items-center px-5">
      <form onSubmit={submit} data-testid="staff-login-form" className="rrb-staff-card w-full max-w-sm">
        <img src="/media/rrb-logo-sm.webp" alt="RR&B 24 Hour Daycare" className="mx-auto h-28 w-auto" />
        <h1 className="mt-4 flex items-center justify-center gap-2 font-display text-2xl font-semibold"><LockKeyhole className="h-5 w-5" /> Staff sign in</h1>
        <p className="mt-1 text-center text-sm text-slate-500">Temporary lead inbox until GoHighLevel is connected.</p>
        <label className="rrb-field mt-6"><span>Email</span>
          <input data-testid="staff-login-email-input" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} />
        </label>
        <label className="rrb-field mt-3"><span>Password</span>
          <input data-testid="staff-login-password-input" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} />
        </label>
        {err && <p data-testid="staff-login-error" className="mt-3 text-sm font-medium text-rose-600">{err}</p>}
        <button data-testid="staff-login-submit-btn" disabled={busy} className="rrb-btn rrb-btn-navy mt-5 w-full justify-center">
          {busy && <Loader2 className="h-4 w-4 animate-spin" />} Sign in
        </button>
        <a href="/" data-testid="staff-back-home-link" className="mt-4 block text-center text-xs text-slate-500 hover:underline">← Back to the website</a>
      </form>
    </div>
  );
}
